import { delay } from "../client.js";

const STORAGE_KEY = "console-design.accounts.v2";

export const SEED_ACCOUNTS = [
  {
    id: "acc-1",
    companyName: "Acme Logistics",
    industry: "Courier & Logistics",
    website: "https://acme.io",
    city: "Bengaluru",
    state: "Karnataka",
    salesPipeline: {
      potentialAcv: "300",
      owner: "karthik",
      stage: "negotiation",
      talkingTo: "Raj Kumar",
      designation: "Fleet Manager",
      keyStakeholders: "Raj Kumar, CFO",
      leadStatus: "qualified",
      assetType: "3W/4W",
      ecosystemRole: "Fleet",
      lastTouchPoint: "26th March — Karthik",
      nextAction: "Send revised proposal",
      expectedClose: "May",
      solutionRequired: "CAN + immob",
      discussionComments: "Interested in immobilizer integration for entire fleet.",
    },
    status: "active",
    tier: "growth",
    fleetSize: 120,
    mrr: 85000,
    internalNotes: "Key enterprise account — quarterly review.",
    contact: { name: "Raj Kumar", role: "Fleet Manager", email: "ops@acme.io", phone: "+91 98765 43210" },
    createdAt: "2024-01-12",
    updatedAt: "2024-01-12",
  },
  {
    id: "acc-2",
    companyName: "Metro Fleet Co",
    industry: "Transportation",
    website: "https://metro.fleet",
    city: "Mumbai",
    state: "Maharashtra",
    salesPipeline: {
      potentialAcv: "500",
      owner: "priya",
      stage: "closed_won",
      talkingTo: "Priya Shah",
      designation: "Operations Head",
      keyStakeholders: "Priya Shah",
      leadStatus: "qualified",
      assetType: "2W, 3W/4W",
      ecosystemRole: "Fleet",
      lastTouchPoint: "10th April — Priya",
      nextAction: "Onboarding kickoff",
      expectedClose: "April",
      solutionRequired: "Telematics + alerts",
      discussionComments: "",
    },
    status: "active",
    tier: "enterprise",
    fleetSize: 340,
    mrr: 210000,
    internalNotes: "",
    contact: { name: "Priya Shah", role: "Operations Head", email: "admin@metro.fleet", phone: "+91 91234 56789" },
    createdAt: "2024-03-08",
    updatedAt: "2024-03-08",
  },
  {
    id: "acc-3",
    companyName: "GreenRide EV",
    industry: "Electric Mobility",
    website: "https://greenride.ev",
    city: "Hyderabad",
    state: "Telangana",
    salesPipeline: {
      potentialAcv: "120",
      owner: "anil",
      stage: "discovery",
      talkingTo: "Anil Reddy",
      designation: "CEO",
      keyStakeholders: "Anil Reddy",
      leadStatus: "contacted",
      assetType: "2W",
      ecosystemRole: "Vehicle OEM",
      lastTouchPoint: "5th Feb — Anil",
      nextAction: "Demo scheduling",
      expectedClose: "July",
      solutionRequired: "Battery analytics",
      discussionComments: "Paused — awaiting fleet expansion.",
    },
    status: "inactive",
    tier: "starter",
    fleetSize: 45,
    mrr: 18000,
    internalNotes: "Paused account.",
    contact: { name: "Anil Reddy", role: "CEO", email: "hello@greenride.ev", phone: "+91 99887 76655" },
    createdAt: "2024-06-21",
    updatedAt: "2024-09-10",
  },
  {
    id: "acc-4",
    companyName: "NorthStar Transport",
    industry: "Freight & Haulage",
    website: "https://northstar.com",
    city: "Chennai",
    state: "Tamil Nadu",
    salesPipeline: {
      potentialAcv: "200",
      owner: "karthik",
      stage: "qualification",
      talkingTo: "",
      designation: "",
      keyStakeholders: "",
      leadStatus: "new",
      assetType: "3W/4W",
      ecosystemRole: "Finance",
      lastTouchPoint: "",
      nextAction: "Initial discovery call",
      expectedClose: "June",
      solutionRequired: "CAN + geofence",
      discussionComments: "Trial ends soon.",
    },
    status: "lead",
    tier: "standard",
    fleetSize: 78,
    mrr: 42000,
    internalNotes: "Trial account.",
    contact: null,
    createdAt: "2025-01-04",
    updatedAt: "2025-01-04",
  },
];

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

function writeStore(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

function getAccounts() {
  return readStore() ?? [...SEED_ACCOUNTS];
}

export async function listAccounts() {
  await delay(140);
  return getAccounts();
}

export async function createAccount(payload) {
  await delay(120);
  const items = getAccounts();
  const next = [payload, ...items];
  writeStore(next);
  return payload;
}

export async function updateAccount(payload) {
  await delay(120);
  const items = getAccounts();
  const i = items.findIndex((x) => x.id === payload.id);
  if (i < 0) throw new Error("Account not found");
  const next = [...items];
  next[i] = payload;
  writeStore(next);
  return payload;
}

export async function deleteAccount(id) {
  await delay(100);
  const items = getAccounts();
  const next = items.filter((x) => x.id !== id);
  writeStore(next);
}
